// Macade Custom Collections: tab switching and slider arrows.
// A custom element so the theme editor re-initialises it when the section
// re-renders (DOMContentLoaded only fires once).
if (!customElements.get('macade-custom-collections')) {
  customElements.define(
    'macade-custom-collections',
    class MacadeCustomCollections extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('button[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab.dataset.tab));
        });

        this.panels.forEach((panel) => this.setupSlider(panel));
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      select(index) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.tab === index;
          tab.classList.toggle(
            'macade-custom-collections__tab--active',
            active
          );
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== index;
        });
      }

      setupSlider(panel) {
        const list = panel.querySelector('.macade-custom-collections__list');
        const prev = panel.querySelector('[data-slider-prev]');
        const next = panel.querySelector('[data-slider-next]');
        if (!list || !prev || !next) return;

        const step = () => {
          const item = list.querySelector('.macade-custom-collections__item');
          if (!item) return list.clientWidth;
          const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
          return item.getBoundingClientRect().width + gap;
        };

        // Arrows sit at the vertical centre of the image, not the whole card,
        // so they stay put when the title is below the image.
        const update = () => {
          // A hidden tab's panel measures 0; it updates again once shown.
          if (!list.offsetHeight) return;
          const media = list.querySelector('.macade-custom-collections__media');
          if (media) {
            const top =
              media.getBoundingClientRect().top -
              panel.getBoundingClientRect().top +
              media.offsetHeight / 2;
            panel.style.setProperty('--mcc-arrow-top', `${top}px`);
          }
          const max = list.scrollWidth - list.clientWidth;
          prev.hidden = list.scrollLeft <= 1;
          next.hidden = list.scrollLeft >= max - 1;
        };

        prev.addEventListener('click', () => list.scrollBy({ left: -step() }));
        next.addEventListener('click', () => list.scrollBy({ left: step() }));
        list.addEventListener('scroll', update, { passive: true });

        // Covers window resizes, images loading and a hidden tab being shown.
        if (!this.resizeObserver) {
          this.updaters = new Map();
          this.resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
              const fn = this.updaters.get(entry.target);
              if (fn) fn();
            });
          });
        }
        this.updaters.set(list, update);
        this.resizeObserver.observe(list);
        update();
      }
    }
  );
}
